import React, { useState } from 'react';
import { Form, Container, Row, Col, Card, Button } from 'react-bootstrap';

const CalendariosAutorizados = () => {
  const [calendarioSeleccionado, setCalendarioSeleccionado] = useState('');

  // 1. Agregamos la propiedad 'ruta' a cada objeto
  const opcionesCalendarios = [
    { id: 'SH-0338-2006-A', nombre: 'H-0338-2006', ruta: 'SH-0338-2006.pdf' },
    { id: 'SH-2426-2026', nombre: '3TRIM_SH-2426-2026', ruta: 'CALEN_3TRIM_SH-2426-2026.pdf' },
  ];

  const handleChange = (e) => {
    setCalendarioSeleccionado(e.target.value);
  };

  const handleVerPdf = () => {
    // 2. Buscamos el objeto seleccionado para obtener su ruta
    const seleccion = opcionesCalendarios.find(c => c.id === calendarioSeleccionado);
    if (seleccion) {
      const urlPdf = `../Pdf/${seleccion.ruta}`;
      window.open(urlPdf, '_blank');
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm border-0 rounded-4">
            <Card.Body className="p-4">
              <Form.Group controlId="formCalendariosAutorizados">
                <Form.Label className="text-secondary small text-uppercase fw-bold mb-3 tracking-wider">
                  Gestión de Calendarios Autorizados
                </Form.Label>
                
                <Form.Select 
                  aria-label="Seleccionar calendario"
                  value={calendarioSeleccionado}
                  onChange={handleChange}
                  className="form-select-lg border-2 shadow-none py-2 px-3 mb-4"
                  style={{
                    borderRadius: '12px',
                    fontSize: '1rem',
                    borderColor: '#e9ecef',
                    transition: 'all 0.2s ease-in-out',
                    cursor: 'pointer'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#0d6efd'}
                  onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                >
                  <option value="" disabled>Seleccione el registro correspondiente...</option>
                  {opcionesCalendarios.map((cal) => (
                    <option key={cal.id} value={cal.id}>
                      {cal.nombre}
                    </option>
                  ))}
                </Form.Select>

                {calendarioSeleccionado ? (
                  <div className="d-grid gap-2 animate__animated animate__fadeIn">
                    <Button 
                      variant="primary" 
                      size="lg" 
                      onClick={handleVerPdf}
                      style={{
                        borderRadius: '12px',
                        fontWeight: '600',
                        backgroundColor: '#691b32',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(13, 110, 253, 0.2)'
                      }}
                    >
                      📄 Ver Archivo PDF
                    </Button>
                    <p className="mt-2 small text-muted text-center">
                      ID Seleccionado: <span className="fw-bold">{calendarioSeleccionado}</span>
                    </p>
                  </div>
                ) : (
                  <Form.Text className="text-muted d-block mt-2 text-center small">
                    Secretaría de Gobierno
                  </Form.Text>
                )}
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CalendariosAutorizados;